import { createContext } from "react";
import { ChecklistItemData, Dispatch, createNewChecklist } from "./checklistModel";

type ContextData = {
  data: ChecklistItemData[]
  dispatch: Dispatch
}

const createInitialContext = (): ContextData => ({
  data: createNewChecklist(),
  dispatch: () => {}
})

export default createContext<ContextData>(createInitialContext())
